import * as request from '../utils/request'

export function get (param) {
  return request.post('self.get', '1.0.0.0', param)
}

export function listOfficer (param) {
  return request.post('self.officer.list', '1.0.0.0', param)
}

export function listMenu (param) {
  return request.post('self.menu.list', '1.0.0.0', param)
}

export function listControl (param) {
  return request.post('self.control.list', '1.0.0.0', param)
}

export function changeOfficer (param) {
  return request.post('self.officer.change', '1.0.0.0', param)
}

export function updatePassword (param) {
  return request.post('self.password.update', '1.0.0.0', param)
}
